import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { hexToRgba } from '@/utils/hexToRgba'
import { ComponentType, FC } from 'react'
import { Pressable, StyleProp, StyleSheet, Text, ViewStyle } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface CustomButtonProps {
    children: string
    LeftIcon?: ComponentType<SvgProps>
    onPress: () => void
    style?: StyleProp<ViewStyle>
}

const CustomButton: FC<CustomButtonProps> = ({ children, LeftIcon, onPress, style }) => {
    return (
        <Pressable
            onPress={onPress}
            style={({ hovered, pressed }) => [
                styles.container,
                hovered && styles.containerHovered,
                pressed && styles.containerPressed,
                style,
            ]}
        >
            <>
                {LeftIcon && <LeftIcon />}
                <Text style={styles.text}>{children}</Text>
            </>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 4,
        height: 32,
        paddingHorizontal: 16,
        gap: 8,
    },
    containerHovered: {
        backgroundColor: hexToRgba(ColorEnum.WHITE, 0.0625),
    },
    containerPressed: {
        backgroundColor: hexToRgba(ColorEnum.WHITE, 0.25),
    },
    text: {
        color: ColorEnum.WHITE,
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 12,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
    },
})

export default CustomButton
